/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_NoneInputs */

const en_coaching_none = /** @type {(inputs: Coaching_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sessions available on your current plan.`)
};

const id_coaching_none = /** @type {(inputs: Coaching_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada sesi tersedia di paket kamu saat ini.`)
};

/**
* | output |
* | --- |
* | "No sessions available on your current plan." |
*
* @param {Coaching_NoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_none = /** @type {((inputs?: Coaching_NoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_NoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_none(inputs)
	return en_coaching_none(inputs)
});